import React, { useState } from "react";
import { Form, Accordion, Card } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { TbWorldCheck } from "react-icons/tb";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";

const CVCreatedPreview = ({ fileSelected, setFileSelected, base64 }) => {
  const [activeKey, setActiveKey] = useState(null);
  // Handler para campos simples
  const handleInputChange = (field, value) => {
    setFileSelected({
      ...fileSelected,
      [field]: value,
      changed: true,
    });
  };

  // Handler para arrays (ex: idiomas, atividadesProfissionais, etc)
  const handleArrayChange = (arrayName, idx, field, value) => {
    const updatedArray = fileSelected[arrayName].map((item, i) =>
      i === idx ? { ...item, [field]: value, changed: true } : item
    );
    setFileSelected({
      ...fileSelected,
      [arrayName]: updatedArray,
      changed: true,
    });
  };

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

      function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "";
    // yyyy-MM-dd → dd/MM/yyyy
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [y, m, d] = dateStr.split("-");
      return `${d}/${m}/${y}`;
    }
    // MM/dd/yyyy → dd/MM/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      const [a, b, c] = dateStr.split("/");
      // Se já está dd/MM/yyyy (dia > 12), retorna igual
      if (parseInt(a, 10) > 12) return dateStr;
      // Se mês > 12, provavelmente já está dd/MM/yyyy
      if (parseInt(b, 10) > 12) return `${b}/${a}/${c}`;
      // Se mês <= 12, assume MM/dd/yyyy
      return `${b}/${a}/${c}`;
    }
    return dateStr;
  }

    const generatePdfView = () => {
    const base64String = atob(base64);
    const bytes = new Uint8Array(base64String.length);
    for (let i = 0; i < base64String.length; i++) {
      bytes[i] = base64String.charCodeAt(i);
    }
    const pdfBlob = new Blob([bytes.buffer], { type: "application/pdf" });
    return URL.createObjectURL(pdfBlob);
  };

  return (
    <div style={{ display: "flex", gap: "20px" }}>
      <div style={{ flex: 1, padding: "10px" }}>
        <iframe
          src={generatePdfView()}
          title="PDF Preview"
          style={{ width: "100%", height: "720px" }}
        />
      </div>
      <div style={{ flex: 1 }} className="scrollBar-cvmanagementModal">
        <Form>
          <Form.Group controlId="nome">
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              value={fileSelected.nome || ""}
              onChange={(e) => handleInputChange("nome", e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="dataNascimento" className="mt-3">
            <Form.Label>Data de Nascimento</Form.Label>
            <Form.Control 
              type="text"
              value={formatDateToDDMMYYYY(fileSelected.dataNascimento || "")}
              onChange={(e) =>
                handleInputChange("dataNascimento", e.target.value)
              }
            />
          </Form.Group>

          <Form.Group controlId="nacionalidade" className="mt-3">
            <Form.Label>Nacionalidade</Form.Label>
            <Form.Control
              type="text"
              value={fileSelected.nacionalidade || ""}
              onChange={(e) =>
                handleInputChange("nacionalidade", e.target.value)
              }
            />
          </Form.Group>

          <Accordion activeKey={activeKey} className="mt-3">
            {/* Percurso Académico */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="0"
                onClick={() => toggleAccordion("0")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Formação Acadêmica</span>
                  <Chip
                    color="primary"
                    label={fileSelected.percursoAcademico.length}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "0" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="0">
                <Card.Body>
                  {fileSelected.percursoAcademico?.map((pa, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 &&
                        fileSelected.percursoAcademico.length > 1 && (
                          <Divider
                            flexItem
                            style={{ margin: "2rem", borderColor: "black" }}
                          />
                        )}
                      <div key={idx} className="mt-3">
                        <Form.Group controlId={`curso-${idx}`}>
                          <Form.Label>Curso</Form.Label>
                          <Form.Control
                            type="text"
                            value={pa.curso || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "percursoAcademico",
                                idx,
                                "curso",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`entidade-${idx}`}>
                          <Form.Label>Entidade</Form.Label>
                          <Form.Control
                            type="text"
                            value={pa.entidade || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "percursoAcademico",
                                idx,
                                "entidade",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`anoInicio-${idx}`}>
                          <Form.Label>Ano Início</Form.Label>
                          <Form.Control
                            type="text"
                            value={pa.anoInicio || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "percursoAcademico",
                                idx,
                                "anoInicio",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`anoConclusao-${idx}`}>
                          <Form.Label>Ano de Conclusão</Form.Label>
                          <Form.Control
                            type="text"
                            value={pa.anoConclusao || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "percursoAcademico",
                                idx,
                                "anoConclusao",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* Formações */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="1"
                onClick={() => toggleAccordion("1")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Formação Complementar</span>
                  <Chip
                    color="primary"
                    label={fileSelected.formacoes.length}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "1" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="1">
                <Card.Body>
                  {fileSelected.formacoes?.map((form, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 && fileSelected.formacoes.length > 1 && (
                        <Divider
                          flexItem
                          style={{ margin: "2rem", borderColor: "black" }}
                        />
                      )}
                      <div key={idx} className="mt-3">
                        <Form.Group controlId={`formacao-${idx}`}>
                          <Form.Label>Formação</Form.Label>
                          <Form.Control
                            type="text"
                            value={form.formacao || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "formacoes",
                                idx,
                                "formacao",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`entidade-formacao-${idx}`}>
                          <Form.Label>Entidade</Form.Label>
                          <Form.Control
                            type="text"
                            value={form.entidade || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "formacoes",
                                idx,
                                "entidade",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`anoInicio-formacao-${idx}`}>
                          <Form.Label>Ano Início</Form.Label>
                          <Form.Control
                            type="text"
                            value={form.anoInicio || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "formacoes",
                                idx,
                                "anoInicio",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`anoConclusao-formacao-${idx}`}>
                          <Form.Label>Ano de Conclusão</Form.Label>
                          <Form.Control
                            type="text"
                            value={form.anoConclusao || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "formacoes",
                                idx,
                                "anoConclusao",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* Línguas */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="3"
                onClick={() => toggleAccordion("3")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Línguas</span>
                  <Chip
                    color="primary"
                    label={fileSelected.proficienciaLinguas.length}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "3" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="3">
                <Card.Body>
                  {fileSelected.proficienciaLinguas?.map((lingua, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 &&
                        fileSelected.proficienciaLinguas.length > 1 && (
                          <Divider
                            flexItem
                            style={{ margin: "2rem", borderColor: "black" }}
                          />
                        )}
                      <div className="mt-3">
                        <Form.Group controlId={`lingua-${idx}`}>
                          <Form.Label>Língua</Form.Label>
                          <Form.Control
                            type="text"
                            value={lingua.lingua || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "proficienciaLinguas",
                                idx,
                                "lingua",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`nivel-${idx}`}>
                          <Form.Label>Nível</Form.Label>
                          <Form.Control
                            type="text"
                            value={lingua.nivel || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "proficienciaLinguas",
                                idx,
                                "nivel",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`nivelLeitura-${idx}`}>
                          <Form.Label>Nível Leitura</Form.Label>
                          <Form.Control
                            type="text"
                            value={lingua.nivelLeitura || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "proficienciaLinguas",
                                idx,
                                "nivelLeitura",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`nivelComunicacao-${idx}`}>
                          <Form.Label>Nível Comunicação</Form.Label>
                          <Form.Control
                            type="text"
                            value={lingua.nivelComunicacao || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "proficienciaLinguas",
                                idx,
                                "nivelComunicacao",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`nivelEscrito-${idx}`}>
                          <Form.Label>Nível Escrito</Form.Label>
                          <Form.Control
                            type="text"
                            value={lingua.nivelEscrito || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "proficienciaLinguas",
                                idx,
                                "nivelEscrito",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* Atividade Profissional */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="2"
                onClick={() => toggleAccordion("2")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Atividade Profissional</span>
                  <Chip
                    color="primary"
                    label={fileSelected.ativProfissional.length}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "2" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="2">
                <Card.Body>
                  {fileSelected.ativProfissional?.map((ap, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 &&
                        fileSelected.ativProfissional.length > 1 && (
                          <Divider
                            flexItem
                            style={{ margin: "2rem", borderColor: "black" }}
                          />
                        )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: idx === 0 ? 0 : 24,
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <Form.Group
                            controlId={`entidade-ativProfissional-${idx}`}
                            style={{ marginBottom: 0 }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Form.Label>Entidade</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                  minWidth: 40,
                                }}
                              >
                                {ap.isInternacional && (
                                  <TbWorldCheck
                                    size={22}
                                    color="#1e90ff"
                                    title="Internacional"
                                  />
                                )}
                                {ap.isProjFinanciado && (
                                  <RiMoneyDollarCircleLine
                                    size={22}
                                    color="#28a745"
                                    title="Projeto Financiado"
                                  />
                                )}
                              </div>
                            </div>
                            <Form.Control
                              type="text"
                              value={ap.entidade || ""}
                              onChange={(e) =>
                                handleArrayChange(
                                  "ativProfissional",
                                  idx,
                                  "entidade",
                                  e.target.value
                                )
                              }
                            />
                          </Form.Group>
                        </div>
                      </div>
                      <div className="mt-2">
                        <Form.Group controlId={`projeto-${idx}`}>
                          <Form.Label>Projeto</Form.Label>
                          <Form.Control
                            type="text"
                            value={ap.projeto || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "ativProfissional",
                                idx,
                                "projeto",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`local-${idx}`}>
                          <Form.Label>Local</Form.Label>
                          <Form.Control
                            type="text"
                            value={ap.local || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "ativProfissional",
                                idx,
                                "local",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`descricao-${idx}`}>
                          <Form.Label>Descrição</Form.Label>
                          <Form.Control
                            type="text"
                            value={ap.descricao || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "ativProfissional",
                                idx,
                                "descricao",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group
                          controlId={`anoInicio-ativProfissional-${idx}`}
                        >
                          <Form.Label>Ano Início</Form.Label>
                          <Form.Control
                            type="text"
                            value={ap.anoInicio || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "ativProfissional",
                                idx,
                                "anoInicio",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group
                          controlId={`anoFim-ativProfissional-${idx}`}
                        >
                          <Form.Label>Ano Fim</Form.Label>
                          <Form.Control
                            type="text"
                            value={ap.anoFim || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "ativProfissional",
                                idx,
                                "anoFim",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* Cargos */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="4"
                onClick={() => toggleAccordion("4")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Cargos</span>
                  <Chip
                    color="primary"
                    label={fileSelected.cargos.length}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "4" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="4">
                <Card.Body>
                  {fileSelected.cargos?.map((cargo, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 && fileSelected.cargos.length > 1 && (
                        <Divider
                          flexItem
                          style={{ margin: "2rem", borderColor: "black" }}
                        />
                      )}
                      <div className="mt-3">
                        <Form.Group controlId={`cargo-cargo-${idx}`}>
                          <Form.Label>Cargo</Form.Label>
                          <Form.Control
                            type="text"
                            value={cargo.cargo || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "cargos",
                                idx,
                                "cargo",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`cargo-entidade-${idx}`}>
                          <Form.Label>Entidade</Form.Label>
                          <Form.Control
                            type="text"
                            value={cargo.entidade || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "cargos",
                                idx,
                                "entidade",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`cargo-anoInicio-${idx}`}>
                          <Form.Label>Ano Início</Form.Label>
                          <Form.Control
                            type="text"
                            value={cargo.anoInicio || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "cargos",
                                idx,
                                "anoInicio",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`cargo-anoFim-${idx}`}>
                          <Form.Label>Ano Fim</Form.Label>
                          <Form.Control
                            type="text"
                            value={cargo.anoFim || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "cargos",
                                idx,
                                "anoFim",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* Domínios */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="5"
                onClick={() => toggleAccordion("5")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Domínios</span>
                  <Chip
                    color="primary"
                    label={fileSelected.dominios?.length || 0}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "5" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="5">
                <Card.Body>
                  {fileSelected.dominios?.map((dom, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 && fileSelected.dominios.length > 1 && (
                        <Divider
                          flexItem
                          style={{ margin: "2rem", borderColor: "black" }}
                        />
                      )}
                      <div className="mt-3">
                        <Form.Group controlId={`dominio-${idx}`}>
                          <Form.Label>Domínio</Form.Label>
                          <Form.Control
                            type="text"
                            value={dom.dominio || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "dominios",
                                idx,
                                "dominio",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`anosExperiencia-${idx}`}>
                          <Form.Label>Anos de Experiência</Form.Label>
                          <Form.Control
                            type="text"
                            value={dom.anosExperiencia || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "dominios",
                                idx,
                                "anosExperiencia",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* Participações */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="6"
                onClick={() => toggleAccordion("6")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Participações</span>
                  <Chip
                    color="primary"
                    label={fileSelected.participacoes?.length || 0}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "6" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="6">
                <Card.Body>
                  {fileSelected.participacoes?.map((part, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 && fileSelected.participacoes.length > 1 && (
                        <Divider
                          flexItem
                          style={{ margin: "2rem", borderColor: "black" }}
                        />
                      )}
                      <div className="mt-3">
                        <Form.Group controlId={`participacao-nome-${idx}`}>
                          <Form.Label>Nome</Form.Label>
                          <Form.Control
                            type="text"
                            value={part.nome || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "participacoes",
                                idx,
                                "nome",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`participacao-ano-${idx}`}>
                          <Form.Label>Ano</Form.Label>
                          <Form.Control
                            type="text"
                            value={part.ano || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "participacoes",
                                idx,
                                "ano",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* Publicações */}
            <Card>
              <Accordion.Toggle
                as={Card.Header}
                eventKey="7"
                onClick={() => toggleAccordion("7")}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexDirection: "row-reverse",
                  }}
                >
                  <span>Publicações</span>
                  <Chip
                    color="primary"
                    label={fileSelected.publicacoes?.length || 0}
                    variant="outlined"
                    size="small"
                  />
                </div>
                {activeKey === "7" ? <FaChevronUp /> : <FaChevronDown />}
              </Accordion.Toggle>
              <Accordion.Collapse style={{ padding: "10px" }} eventKey="7">
                <Card.Body>
                  {fileSelected.publicacoes?.map((pub, idx) => (
                    <React.Fragment key={idx}>
                      {idx !== 0 && fileSelected.publicacoes.length > 1 && (
                        <Divider
                          flexItem
                          style={{ margin: "2rem", borderColor: "black" }}
                        />
                      )}
                      <div className="mt-3">
                        <Form.Group controlId={`publicacao-descricao-${idx}`}>
                          <Form.Label>Descrição</Form.Label>
                          <Form.Control
                            type="text"
                            value={pub.descricao || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "publicacoes",
                                idx,
                                "descricao",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId={`publicacao-ano-${idx}`}>
                          <Form.Label>Ano</Form.Label>
                          <Form.Control
                            type="text"
                            value={pub.ano || ""}
                            onChange={(e) =>
                              handleArrayChange(
                                "publicacoes",
                                idx,
                                "ano",
                                e.target.value
                              )
                            }
                          />
                        </Form.Group>
                      </div>
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Form>
      </div>
    </div>
  );
};

export default CVCreatedPreview;
